export default __webpack_public_path__ + "static/media/sternumMeasurement.51d4e1ff.jpeg";